module.exports = __webpack_public_path__ + "b0785f81a9754d34561ed4d40fe904b9.png";